import { render, staticRenderFns } from "./DaemonConfig.vue?vue&type=template&id=2c980fab"
import script from "./DaemonConfig.vue?vue&type=script&lang=js"
export * from "./DaemonConfig.vue?vue&type=script&lang=js"
import style0 from "./DaemonConfig.vue?vue&type=style&index=0&id=2c980fab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports